// src/pages/Accounting/Reconcile/History/historyTypes.ts

/**
 * One row in the "History by account" table.
 * Richer than the base Reconciliation type because this page shows
 * audit-trail columns (changes, auto adjustment, statement attachment,
 * who signed off).
 */
export interface ReconciliationHistoryEntry {
  id: string;
  accountId: string;
  periodStart: string;
  periodEnd: string;
  statementEndingDate: string;
  reconciledOn: string;
  endingBalance: number;
  /** Number of transactions edited after this period was first reconciled. */
  changes: number;
  /** Dollar amount of the Vela auto-adjustment at sign-off; null if none. */
  autoAdjustment: number | null;
  /** Whether a bank statement PDF was uploaded for this period. */
  statementAttached: boolean;
  /** Optional pre-signed URL to view the uploaded statement. */
  statementUrl?: string;
  /** Full name of the person who signed off (locked the period). */
  reconciledBy: string;
}

/**
 * Dropdown period filter above the history table.
 * The strings match the labels shown in the picker.
 */
export type HistoryPeriodFilter =
  | "last-30-days"
  | "last-90-days"
  | "last-365-days"
  | "year-to-date"
  | "all-time";

export const HISTORY_PERIOD_LABELS: Record<HistoryPeriodFilter, string> = {
  "last-30-days": "Last 30 days",
  "last-90-days": "Last 90 days",
  "last-365-days": "Last 365 days",
  "year-to-date": "Year to date",
  "all-time": "All time",
};

export const DEFAULT_HISTORY_PERIOD: HistoryPeriodFilter = "last-365-days";